import gql from 'graphql-tag';

import client from '../graphqlAPI';

/* getUsersList, trimmed to the fields the Users CSV prints. The full list query also brings
 * history, payment methods, favourites and the whole login log, which put a 5,000-user chunk
 * at ~14 MB — past Lambda's 6 MB response cap, so the export never arrived.
 * latestLoginOnly keeps one session per reader: Last Seen / Last Country need no more. */
const GET_USERS_EXPORT = gql`
query getUsersExport($active: Boolean, $email: String, $name: String, $idNumber: String, $socialnetwork: String, $verified: String, $role: String, $startDate: String, $finishDate: String, $from: Int, $to: Int, $sortingField: String, $sortingType: Int, $getTotal: Boolean, $hasAddress: String, $sendMagazine: String, $includeEligibility: Boolean, $duplicatesOnly: String) {
  getUsersList(active: $active, email: $email, name: $name, idNumber: $idNumber, socialnetwork: $socialnetwork, verified: $verified, role: $role, startDate: $startDate, finishDate: $finishDate, from: $from, to: $to, sortingField: $sortingField, sortingType: $sortingType, getTotal: $getTotal, hasAddress: $hasAddress, sendMagazine: $sendMagazine, includeEligibility: $includeEligibility, duplicatesOnly: $duplicatesOnly, latestLoginOnly: true) {
    isAuth
    total
    error
    users {
      _id
      email
      name
      lastname
      idNumber
      createdAt
      acceptedConditions
      verified
      active
      serverCountry
      socialnetwork
      roles
      originPost
      eligibleForMagazine
      duplicateScore
      duplicatePartner
      duplicateSubscriptionEmail
      loggedFrom {
        lastSeen
        CountryIp
      }
      address {
        street
      }
    }
  }
}
`;

/* Throws instead of returning null like getUsersList does: a chunk that silently comes back
 * empty would produce a CSV with readers missing and nobody the wiser. */
const getUsersExport = async (variables) => {
  const { data, errors } = await client.query({
    query: GET_USERS_EXPORT,
    variables,
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });
  const result = data && data.getUsersList;
  if (!result || !result.isAuth || result.error || (errors && errors.length)) {
    throw new Error((result && result.error) || (errors && errors[0] && errors[0].message) || 'getUsersList failed');
  }
  return result;
};

export default getUsersExport;
